const {KitModule, registerModule} = window;

class LocaleDropdown extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    this.$element.addEventListener('change', this.handleChange.bind(this));
  }

  getUserLocale() {
    return localStorage.getItem('locale');
  }

  /**
   * Build a localized URL when no hreflang link is available, mirroring the
   * static no-JS dropdown link construction.
   * @param {string} localeCode
   * @return {string}
   */
  buildFallbackUrl(localeCode) {
    let path = window.location.pathname;

    if (this.pageLocaleCode) {
      path = path.replace(new RegExp(`^/${this.pageLocaleCode}/`), '/');
    }

    const isDefault = this.locales[localeCode]?.default;
    const prefix = isDefault ? '' : `/${localeCode}`;

    return `${prefix}${path}`;
  }

  /**
   * Store the user's preference, then redirect to the appropriate localization
   * of the current page.
   */
  handleChange() {
    this.userLocaleCode = this.$element.value || this.pageLocaleCode;
    this.setUserLocale();

    const $link = document.querySelector(`link[hreflang="${this.userLocaleCode}"]`);
    if ($link) {
      window.location.href = $link.href;
    } else {
      window.location.href = this.buildFallbackUrl(this.userLocaleCode);
    }
  }

  /**
   * Store user preference in localStorage for convenient access; additionally
   * store as a cookie to be passed to the server.
   */
  setUserLocale() {
    localStorage.setItem('locale', this.userLocaleCode);
    document.cookie = `locale=${this.userLocaleCode}; SameSite=Strict; Secure`;
  }

  setVars() {
    this.locales = {};
    this.$element.childNodes.forEach((option) =>{
      this.locales[option.value] = {
        default: option.dataset.isDefault === 'true',
        label: option.innerText,
      };
    });

    this.pageLocaleCode = this.$element.dataset.pageLocaleCode;
    this.userLocaleCode = this.getUserLocale();
  }

  unmount() {
    //
  }

  /**
   * Display the locale of the current page. Fall back to a stored preference
   * only when the page locale is unavailable in the dropdown options.
   */
  updateUI() {
    const selectedLocaleCode = this.locales[this.pageLocaleCode] ?
      this.pageLocaleCode :
      (this.userLocaleCode || this.pageLocaleCode);

    [...this.$element.options].forEach((option) => {
      option.selected = option.value === selectedLocaleCode;
    });
  }
}

registerModule('LocaleDropdown', LocaleDropdown);
